import React from 'react';
import {
  BarChart,
  Bar,
  PieChart,
  Pie,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from 'recharts';
import { Card } from '../../../shared/components';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8'];

const ReportCharts = ({ data, type, title }) => {
  const renderChart = () => {
    switch (type) {
      case 'issue':
        return (
          <ResponsiveContainer width="100%" height={400}>
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="period" />
              <YAxis yAxisId="left" />
              <YAxis yAxisId="right" orientation="right" />
              <Tooltip />
              <Legend />
              <Line yAxisId="left" type="monotone" dataKey="total_issued" stroke="#8884d8" name="Quantity Issued" />
              {/* <Line yAxisId="right" type="monotone" dataKey="total_cost" stroke="#82ca9d" name="Total Cost" /> */}
            </LineChart>
          </ResponsiveContainer>
        );

      case 'movement':
        return (
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="movement_type" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="total_transactions" fill="#8884d8" name="Transactions" />
              <Bar dataKey="total_quantity" fill="#82ca9d" name="Quantity" />
            </BarChart>
          </ResponsiveContainer>
        );

      case 'top_consumed':
        return (
          <ResponsiveContainer width="100%" height={400}>
            <PieChart>
              <Pie
                data={data}
                dataKey="total_used"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={150}
                label={(entry) => `${entry.name}: ${entry.total_used}`}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        );

      case 'expiry':
        return (
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="quantity_available" fill="#ff6b6b" name="Quantity" />
            </BarChart>
          </ResponsiveContainer>
        );

      default:
        return null;
    }
  };

  return (
    <Card className="mt-6">
      <div className="p-4">
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
        {renderChart()}
      </div>
    </Card>
  );
};

export default ReportCharts;